module.exports = __webpack_public_path__ + "img/thumbnails-5-dom-array-methods.8cf3adc0.png";